import { render, staticRenderFns } from "./CampaignJobCard.vue?vue&type=template&id=f5bbe098"
import script from "./CampaignJobCard.vue?vue&type=script&lang=js"
export * from "./CampaignJobCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignJobCard.vue?vue&type=style&index=0&id=f5bbe098&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports